import API from "../Services/API";
import Model from "./Model";

const useItemisation = (itemisationId, alwaysRefresh) => {
    return Model({
        alwaysRefresh,
        stateKey: ['itemisation', itemisationId],
        fetchData: () => API.get('/pricing/itemisations/' + itemisationId),
        returnDataKey: 'itemisation',
        registerAdditionalMethods: (opts) => {
            return {
                update: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/pricing/itemisations/'+itemisationId, data),
                        data.draft ? 'Draft saved' : 'Changes saved',
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading the itemisation.',
    });
}


export default useItemisation;
